<template>
  <div class="wrap-alert-conten-monitor">
    <v-card class="d-flex pa-1 bg" outlined>
      <div class="mr-auto d-flex">
        <system-linked-combo v-model="select" hide-stack></system-linked-combo>
        <div class="mr-1 wrap-append-align-right">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" class="mr-1" @click="uploadFormOpen()" x-small color="primary"><v-icon small>mdi-progress-upload</v-icon></v-btn>
            </template>
            <span>{{ $t('common.upload') }}</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click="formOpen('new', null)" x-small color="primary"><v-icon small>mdi-plus-circle-outline</v-icon></v-btn>
            </template>
            <span>{{ $t('common.add') }}</span>
          </v-tooltip>
        </div>
      </div>
    </v-card>
    <v-row>
      <v-col cols="12">
        <v-data-table :headers="headers" :items="clonePmList" item-key="programName" :loading="loadings.table" class="elevation-1 content table-pd-s" height="400px" dense fixed-header disable-pagination hide-default-footer>
          <template v-slot:top>
            <MonitorForm :formData="formItem" :formMode="formMode" ref="monitorFormComp" :programNames="programNames" />
          </template>
          <template v-slot:item.active="{ item }">
            <v-simple-checkbox v-model="item.active" disabled class="sp-chk-dense chk-align-c"></v-simple-checkbox>
          </template>
          <template v-slot:item.beginEnd="{ item }">
            <v-simple-checkbox v-model="item.beginEnd" disabled class="sp-chk-dense chk-align-c"></v-simple-checkbox>
          </template>
          <template v-slot:item.elapse="{ item }">
            <v-simple-checkbox v-model="item.elapse" disabled class="sp-chk-dense chk-align-c"></v-simple-checkbox>
          </template>
          <template v-slot:item.elapseTerm="{ item }">
            {{ item.elapseTerm | stringLengthComma }}
          </template>
          <template v-slot:item.notEnd="{ item }">
            <v-simple-checkbox v-model="item.notEnd" disabled class="sp-chk-dense chk-align-c"></v-simple-checkbox>
          </template>
          <template v-slot:item.endTime="{ item }">
            {{ item.endTime | translateTime }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" small class="mr-2" color="primary" @click="formOpen('edit', item)">mdi-pencil-box-multiple-outline</v-icon>
              </template>
              <span>{{ $t('common.edit') }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" small color="primary" @click="deleteItem(item)">mdi-trash-can-outline</v-icon>
              </template>
              <span>{{ $t('common.delete') }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog v-model="uploadDialog" max-width="400px" persistent>
      <v-card :class="classContents">
        <v-card-title>
          <h3>File {{ this.$t('common.upload') }}</h3>
          <v-spacer></v-spacer>
          <v-btn icon x-small @click="closeUpload()">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="meta-form-pd">
          <v-form ref="monitorForm">
            <v-file-input label="File input" v-model="uploadFile" :placeholder="this.$t('common.noFileSelect')" class="w-auto" outlined dense></v-file-input>
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn small @click="upload()" :disabled="btnUploadDisable">{{ this.$t('common.upload') }}</v-btn>
          <v-btn small @click="closeUpload()">{{ this.$t('common.cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { format } from 'date-fns';
import { mapState } from 'vuex';
import _ from 'lodash';
import MonitorForm from './MonitorForm';

export default {
  name: 'Monitor',
  components: {
    MonitorForm,
  },
  data() {
    return {
      loadings: {
        table: true,
      },
      select: { stack: 'ABAP', system: '' },
      formData: {},
      clonePmList: [],
      programNames: [],
      formMode: '',
      formItem: {},
      uploadDialog: false,
      uploadFile: [],
    };
  },
  computed: {
    ...mapState('preference/alert', ['programMonitors', 'uploadMonitorStatus', 'daleteMonitorStatus']),
    headers() {
      const headers = [
        { text: this.$t('alert.monitor.type'), value: 'programTypeName', sortable: false },
        { text: this.$t('alert.monitor.programName'), value: 'programName', sortable: false },
        { text: this.$t('alert.monitor.description'), value: 'programText', width: '20%', sortable: false },
        { text: this.$t('alert.active'), value: 'active', sortable: false },
        { text: this.$t('alert.monitor.beginEnd'), value: 'beginEnd', sortable: false },
        { text: this.$t('alert.monitor.elapse'), value: 'elapse', sortable: false },
        { text: this.$t('alert.monitor.elapseTerm'), value: 'elapseTerm', sortable: false },
        { text: this.$t('alert.monitor.notEnd'), value: 'notEnd', sortable: false },
        { text: this.$t('alert.monitor.endTime'), value: 'endTime', sortable: false },
        { text: this.$t('alert.description'), value: 'programDescription', sortable: false },
        { text: '', value: 'actions', width: '7%', sortable: false },
      ];

      return headers;
    },
    btnUploadDisable() {
      return this.uploadFile.name === undefined ? true : false;
    },
    classContents() {
      return {
        'contents-background-dark': this.$vuetify.theme.isDark,
      };
    },
  },
  filters: {
    stringLengthComma(value) {
      if (!value) return 0;
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    translateTime(value) {
      return value ? format(new Date(value), 'HH:mm:ss') : '';
    },
  },
  watch: {
    'select.system'() {
      this.fetchProgram();
    },
    programMonitors(value) {
      this.clonePmList = _.cloneDeep(value);
      this.programNames = _.map(value, 'programName');
      this.$nextTick(() => {
        this.loadings.table = false;
      });
    },
    uploadMonitorStatus(val) {
      if (val === 'success') {
        this.closeUpload();
        this.sucessMessage();
      }
      if (val === 'error') this.uploadFile = [];
    },
    daleteMonitorStatus(val) {
      if (val === 'success') this.sucessMessage();
    },
  },
  methods: {
    fetchProgram() {
      this.$store.dispatch('preference/alert/monitors', { systemId: this.select.system });
    },
    formOpen(formType = 'new', ...item) {
      this.formItem = {};
      this.formMode = formType;
      if (formType === 'new') {
        this.formItem = {
          systemId: this.select.system,
          programName: '',
          programType: '',
          beginEnd: false,
          notEnd: false,
          elapse: false,
          active: false,
          endTime: 0,
          elapseTerm: 0,
          batchDays: [],
          programDescription: '',
        };
      } else {
        this.formItem = {
          ...item[0],
        };
      }
      this.$refs.monitorFormComp.$data.show = true;
    },
    async deleteItem(item) {
      if (await this.$dialog.confirm(this.$t('common.delete.q'))) {
        this.fetchDeleteMonitor(item);
      }
    },
    fetchDeleteMonitor(item) {
      const params = {
        systemId: this.select.system,
        programName: item.programName,
      };
      this.$store.dispatch('preference/alert/deleteMonitors', params);
    },
    uploadFormOpen() {
      this.uploadDialog = true;
    },
    closeUpload() {
      this.uploadDialog = false;
      this.uploadFile = [];
    },
    upload() {
      const formData = new FormData();
      formData.append('file', this.uploadFile);
      const params = {
        formData: formData,
        infos: { systemId: this.select.system },
      };
      this.$store.dispatch('preference/alert/addMonitorsAll', params);
    },
    sucessMessage() {
      this.$dialog.info(this.$t('common.successful'));
    },
  },
};
</script>
